<template>
    <div class="leading-none mt-auto mb-2 text-shadow-white-3">
        <div class="text-7xl" v-html="time"></div>
        <div class="text-3xl">{{ date }}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                weeks: ["Sun", "Mon", "Thu", "Wed", "Thr", "Fri", "Sat"],
                date: '',
                time: '',
            }
        },
        mounted() {
            this.clock();
            setInterval(this.clock, 1000);
        },
        methods: {
            twoDigit(num) {
                let digit = 0;
                if (num < 10) {
                    digit = "0" + num;
                } else {
                    digit = num;
                }
                return digit;
            },

            clock() {
                let now = new Date();

                let year = now.getFullYear();
                let month = this.twoDigit(now.getMonth() + 1);
                let day = this.twoDigit(now.getDate());
                let week = this.weeks[now.getDay()];
                let hour = this.twoDigit(now.getHours());
                let minute = this.twoDigit(now.getMinutes());
                let second = this.twoDigit(now.getSeconds());

                this.date = year + '.' + month + '.' + day + ' (' + week + ')';
                this.time = hour + ':' + minute + '<span class="text-3xl ml-1">' + second + '</span>';

            },
        },
    }
</script>
